import { TableRow, TableHead, TableCell, useTheme } from '@mui/material'
import React from 'react'

/**
 * @typedef {'small' | 'medium' | 'large'} MUIButtonSize
 * @typedef {'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit' | 'default'} MUIColor
 */
/**
/**
 * Button component for triggering actions.
 *
 * @param {Object} props
 * @param {Array} props.columns - Array of column objects containing label, name, and width properties.
 * @param {String} props.fontSize - Font size for the table header cells.
 * @example
 * const columns = [
 *   { label: 'Name', name: 'name', width: '200px' },
 *   { label: 'Age', name: 'age', width: '100px' },
 *   { label: 'City', name: 'city', width: '150px' }
 * ];
 */

const TableHeader = ( { columns = [], fontSize, textTransform = "capitalize" } ) => {

    const { table, border } = useTheme()

    return (
        <TableHead>
            <TableRow  >
                {columns.map( ( col, index ) => (
                    <TableCell key={index} align={col.align || 'left'} sx={{ fontSize, textTransform, color: table.headerColor, padding: col.padding || "10px 20px", width: col.width, maxWidth: col.maxWidth, minWidth: col.minWidth, ...( col.styles || {} ), borderBottom: border[1] }}>{( col.label || col.name )}</TableCell>
                ) )}
            </TableRow>
        </TableHead >
    )
}

export default TableHeader
